import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Star } from 'lucide-react';
export function Hero() {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-117">
      {/* Background decorative elements */}
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-gold-500/10 blur-3xl" data-id="element-118" />
      <div className="absolute top-1/2 -left-24 h-64 w-64 -translate-y-1/2 rounded-full bg-burgundy-500/5 blur-3xl" data-id="element-119" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="flex flex-col items-center text-center" data-id="element-121">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="mb-6 inline-flex items-center gap-2 rounded-full bg-cream-200 px-4 py-1.5 text-sm font-medium text-burgundy-700" data-id="element-122">
            <span className="flex gap-0.5" data-id="element-123">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="h-3.5 w-3.5 fill-gold-500 text-gold-500" data-id="element-124" />)}
            </span>
            <span data-id="element-125">La guía #1 para emprendedoras desde casa</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mx-auto max-w-4xl text-4xl font-bold leading-tight tracking-tight text-brown-900 sm:text-5xl lg:text-6xl" data-id="element-126">
            Cómo transformar simples{' '}
            <span className="text-burgundy-600" data-id="element-127">budines caseros</span> en
            ingresos reales desde tu cocina…
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-6 max-w-2xl text-xl font-medium text-brown-800/80 sm:text-2xl" data-id="element-128">
            incluso si nunca vendiste nada antes
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative mt-12 w-full max-w-2xl cursor-pointer" onClick={scrollToPurchase} data-id="element-129">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-b from-cream-200/50 to-transparent blur-xl" data-id="element-130" />
            <img src="https://cdn.magicpatterns.com/uploads/oq5ymwAaDAhMNDNwzMmZYu/Untitled_design-removebg-preview.png" alt="Del Horno a Tu Primer Ingreso - Libro y Bonos" className="relative z-10 w-full drop-shadow-2xl transition-transform duration-500 hover:scale-[1.02]" data-id="element-131" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="mt-6 max-w-xl text-base sm:text-lg text-brown-800/70 leading-relaxed" data-id="element-132">
            La guía definitiva + 3 bonos exclusivos que te enseñan paso a paso
            cómo convertir tu pasión por hornear en ingresos reales desde casa —
            sin experiencia previa.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="mt-12 w-full max-w-md" data-id="element-133">
            <Button href="#comprar" className="w-full text-xl py-5" data-id="element-134">
              SÍ, QUIERO EMPEZAR AHORA
            </Button>
            <p className="mt-4 text-sm font-medium text-brown-800/60" data-id="element-135">
              Acceso inmediato • Pago 100% seguro • 100% Digital
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}